import { motion, useInView } from 'motion/react';
import { useRef } from 'react';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { CAREERS_COPY } from '../../../constants/careersTranslations';

export function CareersIntroSection({ lang = 'en', copy }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });
  const t = copy?.intro ?? CAREERS_COPY[lang]?.intro ?? CAREERS_COPY.en.intro;

  return (
    <section ref={ref} className="section-rhythm bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="heading-2 mb-6 text-gray-900"
        >
          {t.title}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.08 }}
          className="text-lg text-gray-600 leading-relaxed mb-8"
        >
          {t.body}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.15 }}
        >
          <Link
            href={t.linkHref ?? '/'}
            className="inline-flex items-center gap-2 text-brand font-semibold hover:gap-3 transition-all"
          >
            {t.linkText}
            <ArrowRight className="w-4 h-4 shrink-0" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
